/* ==========================================================================
   Custom Header — hamburger / mobile dropdown behavior
   Separate custom element tag (header-menu-drawer) so this can safely load
   alongside the Home Hero section's own mobile-menu-drawer on the same page.
   ========================================================================== */

if (!customElements.get('header-menu-drawer')) {
  class HeaderMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.custom-header__hamburger');
      this.panel = this.querySelector('.custom-header__mobile-panel');

      if (!this.button || !this.panel) return;

      this.button.addEventListener('click', () => this.toggle());
      document.addEventListener('click', (event) => this.closeOnOutsideClick(event));
      document.addEventListener('keydown', (event) => this.closeOnEscape(event));
    }

    toggle() {
      const isOpen = this.classList.contains('is-open');
      isOpen ? this.close() : this.open();
    }

    open() {
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
    }

    close() {
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
    }

    closeOnOutsideClick(event) {
      if (!this.classList.contains('is-open')) return;
      if (this.contains(event.target)) return;
      this.close();
    }

    closeOnEscape(event) {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
        this.button.focus();
      }
    }
  }

  customElements.define('header-menu-drawer', HeaderMenuDrawer);
}